export const SetupHomeModuleTranslations: Array<string> = [
  'xmlSetupHome',
  'Admin.ScriptPerformance.ScriptName',
  'Admin.ScriptPerformance.numberOfExecutions',
  'Admin.SetupHome.ScriptPerformanceTitle',
  'Admin.SetupHome.ScriptPerformanceViewMore',
  'Admin.SetupHome.LongestExecutionTime',
  'Admin.SetupHome.AverageExecutionTime',

  //Storage status
  'Admin.SetupHome.StorageStatusTitle',
  'Admin.SetupHome.Database',
  'Admin.SetupHome.FileSystem',
  'Admin.SetupHome.StorageStatus.Used',
  'Admin.SetupHome.StorageStatus.Free',
  //Storage Usages
  'Admin.SetupHome.StorageUsage.Images',
  'Admin.SetupHome.StorageUsage.Documents',
  'Admin.SetupHome.StorageUsage.Proposals',
  'Admin.SetupHome.StorageUsage.Database',
  'Admin.SetupHome.StorageUsages.InGigabytes',
  'Admin.SetupHome.StorageUsagePerDataTypeTitle',
  'Admin.SetupHome.LastSixMonth',
  // Release Notes
  'Admin.SetupHome.ReleaseUpdates.ReleaseSchedule',
  'Admin.SetupHome.ReleaseUpdates.Title',
  'Admin.SetupHome.ReleaseUpdates.Subtitle',
  'Admin.SetupHome.ReleaseUpdates.WhatsNewTitle',
  'Admin.SetupHome.ReleaseUpdates.WhatsNewDescription',
  'Admin.SetupHome.ReleaseUpdates.ReleaseScheduleTitle',
  'Admin.SetupHome.ReleaseUpdates.ReleaseScheduleDescription',
  // System Performance Graph
  'Admin.SetupHome.SystemPerformanceLabel',
  'Admin.SetupHome.SystemPerformanceNumberOfErrors',
  'Admin.SetupHome.SystemPerformanceNumberOfWarnings',
  'Admin.SetupHome.SystemPerformanceNumberOfErrorsAndWarnings',
  'Admin.SetupHome.SystemPerformanceAxisLabelFirstPart',
  'Admin.SetupHome.SystemPerformanceAxisLabelSecondPart',
  'Admin.SetupHome.SystemPerformanceViewMore',
  //System Performance table
  'Admin.SystemPerformanceTable.HeaderLabel',
  'Admin.SystemPerformanceTable.Errors',
  'Admin.SystemPerformanceTable.Warnings',
  'Admin.SystemPerformanceTable.Title',
  'Admin.SystemPerformanceTable.Description',
  'Admin.SystemPerformanceTable.Logger',
  'Admin.SystemPerformanceTable.NumberOfOccurrences',
  //User Licences
  'Admin.SetupHome.UserLicences',
  'Admin.SetupHome.UserLicences.TotalUsers',
  'Admin.SetupHome.UserLicences.ActiveUsers',
  'Admin.SetupHome.UserLicences.UnusedLicences',
  'Admin.SetupHome.AverageExecutionTime',
  'Admin.SetupHome.UserLicences.Unlimited',
  'Admin.SetupHome.UserLicences.NA'
];
